import { gsap } from "gsap";

class Accordion {
    constructor(trigger) {
        this.trigger = trigger;
        this.panelID = null;
        this.content = null;
        this.isOpen = false;

        this.getElements();
        this.checkIsOpen();
        this.addEvents();
        this.handleContent();
    }

    getElements() {
        this.panelID = `#${this.trigger.getAttribute("aria-controls")}`;
        this.content = document.querySelector(this.panelID);
    }

    checkIsOpen() {
        this.isOpen = this.trigger.getAttribute('aria-expanded') === "true";
    }

    addEvents() {
        this.trigger.addEventListener("click", (event) => {
            event.preventDefault();
            if (this.content !== null) {
                this.toggle();
            }
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    close() {
        this.trigger.setAttribute("aria-expanded", "false");

        gsap.to(this.content, {
            opacity: 0,
            height: 0,
            duration: 0.2,
            onStart: () => {
                if (this.content) {
                    this.content.classList.remove("is-active");
                }
            },
            onComplete: () => {
                this.isOpen = false;
                if (this.content) {
                    this.content.classList.add("is-closed");
                }
            },
        });
        this.isOpen = false;
    }

    open() {
        let contentHeight = 0;
        this.content.classList.remove("is-closed");
        this.trigger.setAttribute("aria-expanded", "true");

        gsap.set(this.content, {
            height: "auto",
        });

        contentHeight = this.content.clientHeight;

        gsap.set(this.content, {
            height: 0,
        });

        gsap.to(this.content, {
            opacity: 1,
            height: contentHeight,
            duration: 0.2,
            onComplete: () => {
                this.isOpen = true;
                this.content.classList.add("is-active");
            },
        });
    }

    handleContent() {
        if (this.content === null) {
            this.trigger.classList.add('is-disabled');
        }
    }
}

export function initAccordion() {
    const toggleButtons = document.querySelectorAll("[data-accordion-trigger]");

    if (toggleButtons.length > 0) {
        toggleButtons.forEach((elem) => {
            new Accordion(elem); // eslint-disable-line no-new
        });
    }
}